<script lang="ts" setup>
import { Toaster } from 'vue-sonner'
import { launchNotification } from './notification-settings'
</script>

<template>
  <Toaster
    v-show="launchNotification.toasterOptions.value"
    v-bind="launchNotification.toasterOptions.value"
    expand
  />
</template>
